module.exports = __webpack_public_path__ + "img/japan_normal2_menu.6f4ed919.png";